import { Element } from '../Element'

/**
 * Calculate insert position for new elements (respecting bottom: true logic)
 */
export const calculateInsertPosition = (elements: Element[]): number => {
  // Find the first locked element and insert before it
  const firstLockedIndex = elements.findIndex((el) => el.isLocked())

  // If there are no locked elements, insert at the end
  if (firstLockedIndex === -1) {
    return elements.length
  }

  // Insert before the first locked element
  return firstLockedIndex
}
